import { cx } from "@emotion/css";
import FlatBoxLayout from "library/Layouts/BoxLayout/FlatBoxLayout";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { retrieveContactPaymentType } from "store/features/contact.store";
import DropsSummaryLayout from "../DropsSummaryLayout/DropsSummaryLayout";
import OrderSummaryLineLayout from "../OrderSummaryLineLayout/OrderSummaryLineLayout";

const OrderSummaryBoxLayout = ({
  className,
  contentClassName,
  referenceSection,
  dateSection,
  pickUpSection,
  pickUpNotesSection,
  dropsSection,
  priceSection,
  repeatOrderSection,
  messagesSection,
  collapse,
  ...restProps
}) => {
  const { t } = useTranslation();

  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  return (
    <div className={cx(className, "flex-wrap")} {...restProps}>
      <FlatBoxLayout className={cx(contentClassName, "flex-wrap col-12")} collapse={collapse}>
        {referenceSection && (
          <OrderSummaryLineLayout
            titleSection={t("utils.ui.orderSummary.reference")}
            contentSection={referenceSection}
          />
        )}

        {dateSection && (
          <OrderSummaryLineLayout titleSection={t("utils.ui.orderSummary.date")} contentSection={dateSection} />
        )}

        {pickUpSection && (
          <OrderSummaryLineLayout titleSection={t("utils.ui.orderSummary.pickUp")} contentSection={pickUpSection} />
        )}

        {pickUpNotesSection && (
          <OrderSummaryLineLayout titleSection={t("utils.ui.orderSummary.note")} contentSection={pickUpNotesSection} />
        )}

        {dropsSection && <div className="d-flex flex-row flex-wrap col-12 px-0">{dropsSection}</div>}

        {priceSection && (
          <OrderSummaryLineLayout
            titleSection={isCheckoutPaymentType ? t("utils.pricing.totalPrice") : t("utils.pricing.estimatedCosts")}
            contentSection={priceSection}
          />
        )}

        {repeatOrderSection && (
          <OrderSummaryLineLayout
            titleSection={t("utils.ui.orderSummary.repeat")}
            contentSection={repeatOrderSection}
          />
        )}
      </FlatBoxLayout>

      {messagesSection}
    </div>
  );
};

OrderSummaryBoxLayout.defaultProps = {
  className: null,
  contentClassName: null,
  referenceSection: null,
  dateSection: null,
  pickUpSection: null,
  pickUpNotesSection: null,
  dropsSection: null,
  priceSection: null,
  repeatOrderSection: null,
  messagesSection: null,
  collapse: false,
};

OrderSummaryBoxLayout.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  referenceSection: PropTypes.node,
  dateSection: PropTypes.node,
  pickUpSection: PropTypes.node,
  pickUpNotesSection: PropTypes.node,
  dropsSection: PropTypes.node,
  priceSection: PropTypes.node,
  repeatOrderSection: PropTypes.node,
  messagesSection: PropTypes.node,
  collapse: PropTypes.bool,
};

OrderSummaryBoxLayout.Drops = DropsSummaryLayout;
OrderSummaryBoxLayout.Line = OrderSummaryLineLayout;

export default OrderSummaryBoxLayout;
